export const createPageTitle = (titlePrefix: string): string => {
  return `${titlePrefix} | Experience Oz`
}

// Renders OG Meta tags for link previews
export const renderOpenGraph = (title: string, desc: string, image: string) => {
  return (
    <>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />
    </>
  )
}
